module.exports = __webpack_public_path__ + "assets/Pille-Nurse-Stimmung-happy.ca1cc264.png";